module.exports = window.reactR;